import {
  ClientDocumentOverviewResponse,
  DocumentOverviewBucket,
  DocumentOverviewModel,
  DocumentOverviewResponse,
  DocumentPlaceholderBatch,
} from './document-overview.models';

export function mapDocumentOverviewResponse(response: DocumentOverviewResponse): DocumentOverviewModel {
  return {
    requested: { items: response.requested, totalCount: response.requested.length, hasMore: false, nextAfterId: null },
    reupload_needed: { items: response.reupload_needed, totalCount: response.reupload_needed.length, hasMore: false, nextAfterId: null },
    awaiting_approval: {
      items: response.awaiting_approval,
      totalCount: response.awaiting_approval.length,
      hasMore: false,
      nextAfterId: null,
    },
    approved: { items: response.approved, totalCount: response.approved.length, hasMore: false, nextAfterId: null },
  };
}

export function mapClientDocumentOverviewResponse(response: ClientDocumentOverviewResponse): DocumentOverviewModel {
  return {
    requested: mapBatch(response.requested),
    reupload_needed: mapBatch(response.reupload_needed),
    awaiting_approval: mapBatch(response.awaiting_approval),
    approved: mapBatch(response.approved),
  };
}

function mapBatch(batch: DocumentPlaceholderBatch): DocumentOverviewBucket {
  return { items: batch.items, totalCount: batch.total_count, hasMore: batch.has_more, nextAfterId: batch.next_after_id ?? null };
}
